'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$() {
}
export { $c_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ as $c_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ };
$p = $c_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$() {
}
export { $h_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ as $h_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ };
$h_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$.prototype = $p;
var $d_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$, "presto.TwoFactorAuthView$TwoFactorAuthEmailView$", ({
  Ug: 1
}));
export { $d_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ as $d_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ };
var $n_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$;
function $m_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$() {
  if ((!$n_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$)) {
    $n_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ = new $c_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$();
  }
  return $n_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$;
}
export { $m_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ as $m_Lpresto_TwoFactorAuthView$TwoFactorAuthEmailView$ };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Two-Factor-Auth-Email-View$.js.map
